import { CellCoordinates } from '../types';

export const stringifyCellId = ({ row, column, group }: CellCoordinates) => {
  return `cell-${group}-${column}-${row}`;
};

export const isCellId = (id: string) => {
  return id.startsWith('cell-');
};
